/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Try_Magic_Error_ApiInputs */

const en_try_magic_error_api = /** @type {(inputs: Try_Magic_Error_ApiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API request failed. Please try again.`)
};

const es_try_magic_error_api = /** @type {(inputs: Try_Magic_Error_ApiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La solicitud falló. Por favor inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "API request failed. Please try again." |
*
* @param {Try_Magic_Error_ApiInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const try_magic_error_api = /** @type {((inputs?: Try_Magic_Error_ApiInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Try_Magic_Error_ApiInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_try_magic_error_api(inputs)
	return en_try_magic_error_api(inputs)
});